import React from 'react';
import Header from '../components/Header';
import BookRide from '../components/BookRide';
import Footer from '../components/Footer';
import './Research.css';

const pub = process.env.PUBLIC_URL;

const processCards = [
  {
    icon: 'collab-design.webp',
    title: 'Collaborative Design',
    text: 'Work hand-in-hand with our team of expert engineers and creative designers to bring your vision to life.',
  },
  {
    icon: 'rapid.webp',
    title: 'Rapid Prototyping',
    text: 'We quickly transform concepts into tangible prototypes, ensuring every product is meticulously crafted.',
  },
  {
    icon: 'testing.webp',
    title: 'Testing & Validation',
    text: 'Our rigorous testing and validation processes ensure that each prototype meets high industry standards for functionality, durability, and performance.',
  },
  {
    icon: 'end-to-end.webp',
    title: 'End-to-End Solutions',
    text: 'Our end-to-end solutions cover every phase of development, ensuring that your concept evolves smoothly and efficiently into a finished product.',
  },
];

const domains = [
  {
    title: 'Land-Based Systems',
    text: 'Exploring advanced solutions for mobility, utility, and specialized applications in challenging terrains and urban settings.',
  },
  {
    title: 'Marine Advancements',
    text: 'Creating technologies designed to meet the unique demands of water-based operations, from functionality to adaptability.',
  },
  {
    title: 'Aerial Expansion',
    text: 'Innovating to support diverse needs in airspace, with a focus on efficiency, precision, and safety.',
  },
  {
    title: 'Defense and Security',
    text: 'Partnering with agencies to design custom solutions for mission-critical operations, ensuring reliability and superior performance.',
  },
  {
    title: 'Industrial and Commercial Innovations',
    text: 'Developing tools, equipment, and systems tailored for diverse industries, meeting both large-scale and niche requirements.',
  },
  {
    title: 'AI-Powered IoT Systems',
    text: 'Integrating Artificial Intelligence with the Internet of Things (IoT) to create intelligent, connected operations through real-time data, automation, and predictive insights.',
  },
];

function Research() {
  return (
    <div>
      <Header />

      {/* ── Hero ── */}
      <section
        className="res-hero"
        style={{ backgroundImage: `url(${pub}/research/research-bg.png)` }}
      >
        <div className="res-hero__content">
          <h1 className="res-hero__heading">
            Shape the Future of Technology<br />
            with Acriolis India Motors
          </h1>
          <p className="res-hero__text">
            We redefine innovation across industries. Known for our expertise in ATVs and
            UTVs, our R&amp;D division spans all domains. From land to sea to air, and from
            simple tools to complex machinery, we're your partners in transforming concepts
            into reality.
          </p>
        </div>
      </section>

      {/* ── Collaborate statement ── */}
      <section className="res-collab">
        <h2 className="res-collab__heading">
          Collaborate with Acriolis India Motors and Innovate the Future
        </h2>
        <p className="res-collab__sub">
          Whether you're a student, researcher, or industry professional, we welcome you to
          join our R&amp;D initiatives. Together, we can turn ideas into real-world solutions
          and push the limits of innovation.
        </p>

        <div className="res-process">
          {processCards.map((c) => (
            <div className="res-process__card" key={c.title}>
              <img src={`${pub}/research/${c.icon}`} alt="" className="res-process__icon" />
              <h3 className="res-process__title">{c.title}</h3>
              <p className="res-process__text">{c.text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── Unleash Innovation ── */}
      <section
        className="res-innovate"
        style={{ backgroundImage: `url(${pub}/research/innovation.webp)` }}
      >
        <div className="res-innovate__overlay" />
        <div className="res-innovate__inner">
          <h2 className="res-innovate__heading">
            Unleash Innovation with Acriolis India Motors
          </h2>
          <p className="res-innovate__sub">
            Are you ready to make an impact on the future? Join forces with us to transform
            your most daring ideas into innovative technologies that will reshape industries.
          </p>
          <div className="res-innovate__grid">
            {domains.map((d) => (
              <div className="res-innovate__card" key={d.title}>
                <h3 className="res-innovate__card-title">{d.title}</h3>
                <p className="res-innovate__card-text">{d.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Partner Today ── */}
      <section className="res-partner">
        <div
          className="res-partner__image"
          style={{ backgroundImage: `url(${pub}/research/partner-today.webp)` }}
        />
        <div className="res-partner__content">
          <h2 className="res-partner__heading">
            Partner Today, Lead Tomorrow with Acriolis India Motors
          </h2>
          <p className="res-partner__text">
            From government projects to commercial innovations and defense initiatives, we
            take pride in working across sectors. From prototype to production, Acriolis is
            your trusted partner in developing everything from basic tools to advanced systems.
          </p>
          <h3 className="res-partner__subheading">A Proven Legacy of Success</h3>
          <p className="res-partner__text">
            Acriolis India Motors has a proven track record of successfully developing
            off-road vehicles from scratch for both commercial and defense sectors, tailored
            to their specific requirements. We have delivered high-performance, reliable
            solutions that meet the unique challenges of each sector, ensuring our vehicles
            excel in demanding environments. From concept to execution, we've turned complex
            requirements into impactful, durable vehicles.
          </p>
        </div>
      </section>

      <BookRide />
      <Footer />
    </div>
  );
}

export default Research;
